import { connect } from 'react-redux';
import View from './DoYouHaveChildrenView';

import {
  currentClientId,
  data2,
  isPopulatedSelector,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import childrenSelector from './ChildrenOverviewSelector';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import { personalInfoSelector } from '../PersonalInfoWorkflowSelector';
import nextIteratorsSelector from './DoYouHaveChildrenSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  hasChildren: data2(state, ownProps)(`${BACKEND_KEY}.HasChildren`),
  children: childrenSelector(state, ownProps),
  alreadyHadChildrenData: data2(state, ownProps)(`${BACKEND_KEY}.AlreadyHadChildrenData`),
  isPopulated: isPopulatedSelector(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
  personalInfo: personalInfoSelector(state, ownProps),
  nextIterators: nextIteratorsSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  preprocessData: (clientId, children, store2) => {
    if (children.length > 0) {
      store2(
        {
          [BACKEND_KEY]: {
            HasChildren: true,
            AlreadyHadChildrenData: true,
          },
        },
        clientId,
      );
    }
  },
  onPostProcess: (hasChildren, personalInfo, store, clientId) => (data) => {
    if (!hasChildren) {
      store(
        {
          [BACKEND_KEY]: {
            Dependents: [],
          },
        },
        clientId,
      );
      return {
        ...data,
        [BACKEND_KEY]: {
          ...personalInfo,
          Dependents: [],
        },
      };
    }
    return data;
  },
  hasChildrenClicked: (clientId, store2) => (event) => {
    store2(
      {
        [BACKEND_KEY]: {
          HasChildren: event.target.checked,
        },
      },
      clientId,
    );
  },
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
